import {getCookies} from '@/utils/cookies'
import CallCenterCRM from '@/api/CallCenterCrm.js'
const user = {
  state: {
    token: getCookies('authToken'),
    isAdmin: false,
    googleMapApiKey: '',
    dateTimeFormate: '',
    permission: [],
    latitude: '',
    longitude: '',
    activeCallerWindow: false
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_PERMISSION: (state, permission) => {
      state.permission = permission
    },
    SET_ADMIN: (state, isAdmin) => {
      state.isAdmin = isAdmin
    },
    SET_MAPAPI: (state, mapApi) => {
      state.googleMapApiKey = mapApi
    },
    SET_DATETIMEFORMAT: (state, dateTimeFormat) => {
      state.dateTimeFormate = dateTimeFormat
    },
    SET_COMPANYLATITUDE: (state, latitude) => {
      state.latitude = latitude
    },
    SET_COMPANYLONGITUDE: (state, longitude) => {
      state.longitude = longitude
    },
    SET_ACTIVECALLERWINDOW: (state, activeCallerWindow) => {
      state.activeCallerWindow = activeCallerWindow
    }
  },
  actions: {
    SetToken ({commit}, token) {
      commit('SET_TOKEN', token)
    },
    SetPermission ({commit}, permission) {
      commit('SET_PERMISSION', permission)
    },
    SetAdmin ({commit}, isadmin) {
      commit('SET_ADMIN', isadmin)
    },
    SetMapKey ({commit}, key) {
      commit('SET_MAPAPI', key)
    },
    SetCompanylatitude ({commit}, latitude) {
      commit('SET_COMPANYLATITUDE', latitude)
    },
    SetCompanylongitude ({commit}, longitude) {
      commit('SET_COMPANYLONGITUDE', longitude)
    },
    SetCallerWIndowStatus ({commit}, isActive) {
      commit('SET_ACTIVECALLERWINDOW', isActive)
    },
    GetUserPermission ({commit, getters, dispatch}, logOut) {
      if (logOut) {
        commit('SET_PERMISSION', [])
      } else {
        return new Promise((resolve, reject) => {
          CallCenterCRM.getUserLoginPermission(
            response => {
              commit('SET_ACTIVECALLERWINDOW', true)
              commit('SET_PERMISSION', response.Data)
              commit('SET_ADMIN', response.Data.isAdmin)
              commit('SET_MAPAPI', response.Data.googleMapApiKey)
              commit('SET_DATETIMEFORMAT', response.Data.dateTimeFormat)
              commit('SET_COMPANYLATITUDE', response.Data.latitude)
              commit('SET_COMPANYLONGITUDE', response.Data.longitude)
              resolve(response.Data)
            },
            (error) => {
              console.log(error)
              reject(error)
            }
          )
        })
      }
    }
  }
}
export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js